import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Sets a correct canonical URL on every route.
//
// The problem this fixes: index.html carries one hard-coded canonical pointing
// at the homepage, and it stays on every page as you navigate. Google reads
// that as "this page is a duplicate of the homepage" and drops it from the
// index. On a site with 30+ location pages, that means none of them rank.
//
// Mount this once inside your Router and it corrects every page, including the
// ones that exist already. It updates the existing tag if there is one and
// creates it if there isn't, so you do not have to touch index.html.

const ORIGIN = 'https://www.citicool.in';

export default function Canonical() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Strip any query string and trailing slash. A canonical should be the one
    // clean address for the page — ?gclid=... variants must not each become
    // their own URL.
    const clean = pathname.replace(/\/+$/, '') || '/';
    const href = clean === '/' ? `${ORIGIN}/` : `${ORIGIN}${clean}`;

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', href);

    // og:url should agree with the canonical. If they disagree, shares and
    // search see two different addresses for the same page.
    let og = document.head.querySelector('meta[property="og:url"]');
    if (!og) {
      og = document.createElement('meta');
      og.setAttribute('property', 'og:url');
      document.head.appendChild(og);
    }
    og.setAttribute('content', href);

    const tw = document.head.querySelector('meta[property="twitter:url"], meta[name="twitter:url"]');
    if (tw) tw.setAttribute('content', href);
  }, [pathname]);

  return null;
}